/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const TextSearch = [
  ["path", { d: "M21 5H3" }],
  ["path", { d: "M10 12H3" }],
  ["path", { d: "M10 19H3" }],
  ["circle", { cx: "17", cy: "15", r: "3" }],
  ["path", { d: "m21 19-1.9-1.9" }]
];

export { TextSearch as default };
//# sourceMappingURL=text-search.js.map
